import { VideoOtherProps, VideoTypes } from "./types";
import LocalPlayer from "./LocalPlayer";
import React, { ComponentType } from "react";
import YouTubePlayer from "./YouTubePlayer";

const VIDEO_TYPE_COMPONENTS: { [key in VideoTypes]: ComponentType<any> } = {
  local: LocalPlayer,
  youtube: YouTubePlayer,
};

const DefaultVideo = (props: VideoOtherProps) => {
  const { videoType, ...otherProps } = props;
  const NullComponent = () => {
    return null;
  };
  const PlayerComponent = videoType
    ? VIDEO_TYPE_COMPONENTS?.[videoType]
    : NullComponent;
  return <PlayerComponent {...otherProps} />;
};

export default DefaultVideo;
